/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ErrorCode, ClaimType } from '@constants';
import { useReviewData, useBehaviorData } from '@hooks';
import { logError } from '@log';
import { setDelayPackageId } from '@store';

export const useDelay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const setReportData = useBehaviorData();
  const [isLoading, setIsLoading] = useState(false);
  const {
    fulfilledItems,
    unFulfilledItems, orderName, delayPackageId,
  } = useSelector((state) => state.claim);
  // const { getReviewData } = useReviewData();

  const onChange = (event) => {
    dispatch(setDelayPackageId(event?.target?.value));
  };

  const onClickTitle = (item) => {
    dispatch(setDelayPackageId(item.fulfilledId));
  };

  const onClickContinue = async () => {
    try {
      setReportData({ optionsIssueTime: Date.now(), issueType: ClaimType.Delay });
      setIsLoading(true);
      if (!delayPackageId) {
        logError(new Error('delay onClickContinue no package'));
        return;
      }
      // const isSuccess = await getReviewData();
      navigate('/17track/payment');
      setIsLoading(false);
      // if (isSuccess) {
      //   navigate('/17track/review');
      //   return;
      // }
      // navigate('/17track/error', { state: { code: ErrorCode.Wrong } });
    } catch (error) {
      logError(error);
    }
  };

  const onClickBack = () => {
    dispatch(setDelayPackageId(''));
  };

  return {
    fulfilledItems,
    unFulfilledItems,
    isBtnDisable: !delayPackageId,
    delayPackageId,
    orderName,
    isLoading,
    onChange,
    onClickTitle,
    onClickContinue,
    onClickBack,
  };
};
